import axiosInstance from './axios';

export interface CountryAuthorization {
  authorized: boolean;
  countryIso2: string | null;
  countryName: string | null;
}

export const isCountryAuthorized = async (): Promise<CountryAuthorization> => {
  try {
    const response = await axiosInstance.get('/localisation/is-authorized');
    return response.data as CountryAuthorization;
  } catch (error) {
    throw new Error('Erreur lors de la récupération de la localisation');
  }
};
